import {
  UnitUtil,
  ConversionBaseSingle,
  ConversionBaseAbc,
  ConversionArrayAbc,
  Fraction,
} from '../../genEq/genHelper';

export class PrevodJednotek__Delka__1 extends ConversionBaseAbc {
  constructor() {
    super(
      (r) => UnitUtil.getRandomOpts(r, UnitUtil.logLength()),
      UnitUtil.coeff_1,
      'PrevodJednotek__Delka__1'
    );
  }
}
export class PrevodJednotek__Delka__N extends ConversionBaseAbc {
  constructor() {
    super(
      (r) => UnitUtil.getRandomOpts(r, UnitUtil.logLength()),
      UnitUtil.coeff_n,
      'PrevodJednotek__Delka__N'
    );
  }
}
export class PrevodJednotek__Delka__N_N extends ConversionBaseAbc {
  constructor() {
    super(
      (r) => UnitUtil.getRandomOpts(r, UnitUtil.logLength()),
      UnitUtil.coeff_n_n,
      'PrevodJednotek__Delka__N_N'
    );
  }
}
export class PrevodJednotek__Delka__1Q extends ConversionBaseSingle {
  constructor() {
    super(
      (r) => UnitUtil.getRandomConversion(r, UnitUtil.logLength()),
      true,
      UnitUtil.coeff_1,
      'PrevodJednotek__Delka__1Q'
    );
  }
}
export class PrevodJednotek__Delka__NQ extends ConversionBaseSingle {
  constructor() {
    super(
      (r) => UnitUtil.getRandomConversion(r, UnitUtil.logLength()),
      true,
      UnitUtil.coeff_n,
      'PrevodJednotek__Delka__NQ'
    );
  }
}
export class PrevodJednotek__Delka__N_NQ extends ConversionBaseSingle {
  constructor() {
    super(
      (r) => UnitUtil.getRandomConversion(r, UnitUtil.logLength()),
      true,
      UnitUtil.coeff_n_n,
      'PrevodJednotek__Delka__N_NQ'
    );
  }
}
export class PrevodJednotek__Plocha__1 extends ConversionBaseAbc {
  constructor() {
    super(
      (r) => UnitUtil.getRandomOpts(r, UnitUtil.logSurface()),
      UnitUtil.coeff_1,
      'PrevodJednotek__Plocha__1'
    );
  }
}
export class PrevodJednotek__Plocha__N extends ConversionBaseAbc {
  constructor() {
    super(
      (r) => UnitUtil.getRandomOpts(r, UnitUtil.logSurface()),
      UnitUtil.coeff_n,
      'PrevodJednotek__Plocha__N'
    );
  }
}
export class PrevodJednotek__Plocha__N_N extends ConversionBaseAbc {
  constructor() {
    super(
      (r) => UnitUtil.getRandomOpts(r, UnitUtil.logSurface()),
      UnitUtil.coeff_n_n,
      'PrevodJednotek__Plocha__N_N'
    );
  }
}
export class PrevodJednotek__Plocha__1Q extends ConversionBaseSingle {
  constructor() {
    super(
      (r) => UnitUtil.getRandomConversion(r, UnitUtil.logSurface()),
      true,
      UnitUtil.coeff_1,
      'PrevodJednotek__Plocha__1Q'
    );
  }
}
export class PrevodJednotek__Plocha__NQ extends ConversionBaseSingle {
  constructor() {
    super(
      (r) => UnitUtil.getRandomConversion(r, UnitUtil.logSurface()),
      true,
      UnitUtil.coeff_n,
      'PrevodJednotek__Plocha__NQ'
    );
  }
}
export class PrevodJednotek__Plocha__N_NQ extends ConversionBaseSingle {
  constructor() {
    super(
      (r) => UnitUtil.getRandomConversion(r, UnitUtil.logSurface()),
      true,
      UnitUtil.coeff_n_n,
      'PrevodJednotek__Plocha__N_NQ'
    );
  }
}
export class PrevodJednotek__Objem__1 extends ConversionBaseAbc {
  constructor() {
    super(
      (r) => UnitUtil.getRandomOpts(r, UnitUtil.logVolume()),
      UnitUtil.coeff_1,
      'PrevodJednotek__Objem__1'
    );
  }
}
export class PrevodJednotek__Objem__N extends ConversionBaseAbc {
  constructor() {
    super(
      (r) => UnitUtil.getRandomOpts(r, UnitUtil.logVolume()),
      UnitUtil.coeff_n,
      'PrevodJednotek__Objem__N'
    );
  }
}
export class PrevodJednotek__Objem__N_N extends ConversionBaseAbc {
  constructor() {
    super(
      (r) => UnitUtil.getRandomOpts(r, UnitUtil.logVolume()),
      UnitUtil.coeff_n_n,
      'PrevodJednotek__Objem__N_N'
    );
  }
}
export class PrevodJednotek__Objem__1Q extends ConversionBaseSingle {
  constructor() {
    super(
      (r) => UnitUtil.getRandomConversion(r, UnitUtil.logVolume()),
      true,
      UnitUtil.coeff_1,
      'PrevodJednotek__Objem__1Q'
    );
  }
}
export class PrevodJednotek__Objem__NQ extends ConversionBaseSingle {
  constructor() {
    super(
      (r) => UnitUtil.getRandomConversion(r, UnitUtil.logVolume()),
      true,
      UnitUtil.coeff_n,
      'PrevodJednotek__Objem__NQ'
    );
  }
}
export class PrevodJednotek__Objem__N_NQ extends ConversionBaseSingle {
  constructor() {
    super(
      (r) => UnitUtil.getRandomConversion(r, UnitUtil.logVolume()),
      true,
      UnitUtil.coeff_n_n,
      'PrevodJednotek__Objem__N_NQ'
    );
  }
}
export class PrevodJednotek__Hmotnost__1 extends ConversionBaseAbc {
  constructor() {
    super(
      (r) => UnitUtil.getRandomOpts(r, UnitUtil.logWeight()),
      UnitUtil.coeff_1,
      'PrevodJednotek__Hmotnost__1'
    );
  }
}
export class PrevodJednotek__Hmotnost__N extends ConversionBaseAbc {
  constructor() {
    super(
      (r) => UnitUtil.getRandomOpts(r, UnitUtil.logWeight()),
      UnitUtil.coeff_n,
      'PrevodJednotek__Hmotnost__N'
    );
  }
}
export class PrevodJednotek__Hmotnost__N_N extends ConversionBaseAbc {
  constructor() {
    super(
      (r) => UnitUtil.getRandomOpts(r, UnitUtil.logWeight()),
      UnitUtil.coeff_n_n,
      'PrevodJednotek__Hmotnost__N_N'
    );
  }
}
export class PrevodJednotek__Hmotnost__1Q extends ConversionBaseSingle {
  constructor() {
    super(
      (r) => UnitUtil.getRandomConversion(r, UnitUtil.logWeight()),
      true,
      UnitUtil.coeff_1,
      'PrevodJednotek__Hmotnost__1Q'
    );
  }
}
export class PrevodJednotek__Hmotnost__NQ extends ConversionBaseSingle {
  constructor() {
    super(
      (r) => UnitUtil.getRandomConversion(r, UnitUtil.logWeight()),
      true,
      UnitUtil.coeff_n,
      'PrevodJednotek__Hmotnost__NQ'
    );
  }
}
export class PrevodJednotek__Hmotnost__N_NQ extends ConversionBaseSingle {
  constructor() {
    super(
      (r) => UnitUtil.getRandomConversion(r, UnitUtil.logWeight()),
      true,
      UnitUtil.coeff_n_n,
      'PrevodJednotek__Hmotnost__N_NQ'
    );
  }
}
export class PrevodJednotek__DelkaUS__1 extends ConversionBaseSingle {
  constructor() {
    super(
      (r) => UnitUtil.getRandomConversion(r, UnitUtil.decImperialLength()),
      false,
      UnitUtil.coeff_1,
      'PrevodJednotek__DelkaUS__1'
    );
  }
}
export class PrevodJednotek__DelkaUS__N extends ConversionBaseSingle {
  constructor() {
    super(
      (r) => UnitUtil.getRandomConversion(r, UnitUtil.decImperialLength()),
      false,
      UnitUtil.coeff_n,
      'PrevodJednotek__DelkaUS__N'
    );
  }
}
export class PrevodJednotek__DelkaUS__N_N extends ConversionBaseSingle {
  constructor() {
    super(
      (r) => UnitUtil.getRandomConversion(r, UnitUtil.decImperialLength()),
      false,
      UnitUtil.coeff_n_n,
      'PrevodJednotek__DelkaUS__N_N'
    );
  }
}
export class PrevodJednotek__DelkaUS__1Q extends ConversionBaseSingle {
  constructor() {
    super(
      (r) => UnitUtil.getRandomConversion(r, UnitUtil.decImperialLength()),
      true,
      UnitUtil.coeff_1,
      'PrevodJednotek__DelkaUS__1Q'
    );
  }
}
export class PrevodJednotek__DelkaUS__NQ extends ConversionBaseSingle {
  constructor() {
    super(
      (r) => UnitUtil.getRandomConversion(r, UnitUtil.decImperialLength()),
      true,
      UnitUtil.coeff_n,
      'PrevodJednotek__DelkaUS__NQ'
    );
  }
}
export class PrevodJednotek__DelkaUS__N_NQ extends ConversionBaseSingle {
  constructor() {
    super(
      (r) => UnitUtil.getRandomConversion(r, UnitUtil.decImperialLength()),
      true,
      UnitUtil.coeff_n_n,
      'PrevodJednotek__DelkaUS__N_NQ'
    );
  }
}
export class PrevodJednotek__ObjemUS__1 extends ConversionBaseSingle {
  constructor() {
    super(
      (r) => UnitUtil.getRandomConversion(r, UnitUtil.decImperialVolume()),
      false,
      UnitUtil.coeff_1,
      'PrevodJednotek__ObjemUS__1'
    );
  }
}
export class PrevodJednotek__ObjemUS__N extends ConversionBaseSingle {
  constructor() {
    super(
      (r) => UnitUtil.getRandomConversion(r, UnitUtil.decImperialVolume()),
      false,
      UnitUtil.coeff_n,
      'PrevodJednotek__ObjemUS__N'
    );
  }
}
export class PrevodJednotek__ObjemUS__N_N extends ConversionBaseSingle {
  constructor() {
    super(
      (r) => UnitUtil.getRandomConversion(r, UnitUtil.decImperialVolume()),
      false,
      UnitUtil.coeff_n_n,
      'PrevodJednotek__ObjemUS__N_N'
    );
  }
}
export class PrevodJednotek__ObjemUS__1Q extends ConversionBaseSingle {
  constructor() {
    super(
      (r) => UnitUtil.getRandomConversion(r, UnitUtil.decImperialVolume()),
      true,
      UnitUtil.coeff_1,
      'PrevodJednotek__ObjemUS__1Q'
    );
  }
}
export class PrevodJednotek__ObjemUS__NQ extends ConversionBaseSingle {
  constructor() {
    super(
      (r) => UnitUtil.getRandomConversion(r, UnitUtil.decImperialVolume()),
      true,
      UnitUtil.coeff_n,
      'PrevodJednotek__ObjemUS__NQ'
    );
  }
}
export class PrevodJednotek__ObjemUS__N_NQ extends ConversionBaseSingle {
  constructor() {
    super(
      (r) => UnitUtil.getRandomConversion(r, UnitUtil.decImperialVolume()),
      true,
      UnitUtil.coeff_n_n,
      'PrevodJednotek__ObjemUS__N_NQ'
    );
  }
}
export class PrevodJednotek__HmotnostUS__1 extends ConversionBaseSingle {
  constructor() {
    super(
      (r) => UnitUtil.getRandomConversion(r, UnitUtil.decImperialMass()),
      false,
      UnitUtil.coeff_1,
      'PrevodJednotek__HmotnostUS__1'
    );
  }
}
export class PrevodJednotek__HmotnostUS__N extends ConversionBaseSingle {
  constructor() {
    super(
      (r) => UnitUtil.getRandomConversion(r, UnitUtil.decImperialMass()),
      false,
      UnitUtil.coeff_n,
      'PrevodJednotek__HmotnostUS__N'
    );
  }
}
export class PrevodJednotek__HmotnostUS__N_N extends ConversionBaseSingle {
  constructor() {
    super(
      (r) => UnitUtil.getRandomConversion(r, UnitUtil.decImperialMass()),
      false,
      UnitUtil.coeff_n_n,
      'PrevodJednotek__HmotnostUS__N_N'
    );
  }
}
export class PrevodJednotek__HmotnostUS__1Q extends ConversionBaseSingle {
  constructor() {
    super(
      (r) => UnitUtil.getRandomConversion(r, UnitUtil.decImperialMass()),
      true,
      UnitUtil.coeff_1,
      'PrevodJednotek__HmotnostUS__1Q'
    );
  }
}
export class PrevodJednotek__HmotnostUS__NQ extends ConversionBaseSingle {
  constructor() {
    super(
      (r) => UnitUtil.getRandomConversion(r, UnitUtil.decImperialMass()),
      true,
      UnitUtil.coeff_n,
      'PrevodJednotek__HmotnostUS__NQ'
    );
  }
}
export class PrevodJednotek__HmotnostUS__N_NQ extends ConversionBaseSingle {
  constructor() {
    super(
      (r) => UnitUtil.getRandomConversion(r, UnitUtil.decImperialMass()),
      true,
      UnitUtil.coeff_n_n,
      'PrevodJednotek__HmotnostUS__N_NQ'
    );
  }
}
export class PrevodJednotek__Cas__1 extends ConversionBaseSingle {
  constructor() {
    super(
      (r) => UnitUtil.getRandomConversion(r, UnitUtil.decMetricTime()),
      false,
      UnitUtil.coeff_1,
      'PrevodJednotek__Cas__1'
    );
  }
}
export class PrevodJednotek__Cas__N extends ConversionBaseSingle {
  constructor() {
    super(
      (r) => UnitUtil.getRandomConversion(r, UnitUtil.decMetricTime()),
      false,
      UnitUtil.coeff_n,
      'PrevodJednotek__Cas__N'
    );
  }
}
export class PrevodJednotek__Cas__N_N extends ConversionBaseSingle {
  constructor() {
    super(
      (r) => UnitUtil.getRandomConversion(r, UnitUtil.decMetricTime()),
      false,
      UnitUtil.coeff_n_n,
      'PrevodJednotek__Cas__N_N'
    );
  }
}
export class PrevodJednotek__Cas__1Q extends ConversionBaseSingle {
  constructor() {
    super(
      (r) => UnitUtil.getRandomConversion(r, UnitUtil.decMetricTime()),
      true,
      UnitUtil.coeff_1,
      'PrevodJednotek__Cas__1Q'
    );
  }
}
export class PrevodJednotek__Cas__NQ extends ConversionBaseSingle {
  constructor() {
    super(
      (r) => UnitUtil.getRandomConversion(r, UnitUtil.decMetricTime()),
      true,
      UnitUtil.coeff_n,
      'PrevodJednotek__Cas__NQ'
    );
  }
}
export class PrevodJednotek__Cas__N_NQ extends ConversionBaseSingle {
  constructor() {
    super(
      (r) => UnitUtil.getRandomConversion(r, UnitUtil.decMetricTime()),
      true,
      UnitUtil.coeff_n_n,
      'PrevodJednotek__Cas__N_NQ'
    );
  }
}
export class PrevodJednotek__Sila__1 extends ConversionBaseAbc {
  constructor() {
    super(
      (r) => UnitUtil.getRandomOpts(r, UnitUtil.logSiPrefixes('N')),
      UnitUtil.coeff_1,
      'PrevodJednotek__Sila__1'
    );
  }
}
export class PrevodJednotek__Sila__N extends ConversionBaseAbc {
  constructor() {
    super(
      (r) => UnitUtil.getRandomOpts(r, UnitUtil.logSiPrefixes('N')),
      UnitUtil.coeff_n,
      'PrevodJednotek__Sila__N'
    );
  }
}
export class PrevodJednotek__Sila__N_N extends ConversionBaseAbc {
  constructor() {
    super(
      (r) => UnitUtil.getRandomOpts(r, UnitUtil.logSiPrefixes('N')),
      UnitUtil.coeff_n_n,
      'PrevodJednotek__Sila__N_N'
    );
  }
}
export class PrevodJednotek__Sila__1Q extends ConversionBaseSingle {
  constructor() {
    super(
      (r) => UnitUtil.getRandomConversion(r, UnitUtil.logSiPrefixes('N')),
      true,
      UnitUtil.coeff_1,
      'PrevodJednotek__Sila__1Q'
    );
  }
}
export class PrevodJednotek__Sila__NQ extends ConversionBaseSingle {
  constructor() {
    super(
      (r) => UnitUtil.getRandomConversion(r, UnitUtil.logSiPrefixes('N')),
      true,
      UnitUtil.coeff_n,
      'PrevodJednotek__Sila__NQ'
    );
  }
}
export class PrevodJednotek__Sila__N_NQ extends ConversionBaseSingle {
  constructor() {
    super(
      (r) => UnitUtil.getRandomConversion(r, UnitUtil.logSiPrefixes('N')),
      true,
      UnitUtil.coeff_n_n,
      'PrevodJednotek__Sila__N_NQ'
    );
  }
}
export class PrevodJednotek__Energie__1 extends ConversionBaseAbc {
  constructor() {
    super(
      (r) => UnitUtil.getRandomOpts(r, UnitUtil.logSiPrefixes('J')),
      UnitUtil.coeff_1,
      'PrevodJednotek__Energie__1'
    );
  }
}
export class PrevodJednotek__Energie__N extends ConversionBaseAbc {
  constructor() {
    super(
      (r) => UnitUtil.getRandomOpts(r, UnitUtil.logSiPrefixes('J')),
      UnitUtil.coeff_n,
      'PrevodJednotek__Energie__N'
    );
  }
}
export class PrevodJednotek__Energie__N_N extends ConversionBaseAbc {
  constructor() {
    super(
      (r) => UnitUtil.getRandomOpts(r, UnitUtil.logSiPrefixes('J')),
      UnitUtil.coeff_n_n,
      'PrevodJednotek__Energie__N_N'
    );
  }
}
export class PrevodJednotek__Energie__1Q extends ConversionBaseSingle {
  constructor() {
    super(
      (r) => UnitUtil.getRandomConversion(r, UnitUtil.logSiPrefixes('J')),
      true,
      UnitUtil.coeff_1,
      'PrevodJednotek__Energie__1Q'
    );
  }
}
export class PrevodJednotek__Energie__NQ extends ConversionBaseSingle {
  constructor() {
    super(
      (r) => UnitUtil.getRandomConversion(r, UnitUtil.logSiPrefixes('J')),
      true,
      UnitUtil.coeff_n,
      'PrevodJednotek__Energie__NQ'
    );
  }
}
export class PrevodJednotek__Energie__N_NQ extends ConversionBaseSingle {
  constructor() {
    super(
      (r) => UnitUtil.getRandomConversion(r, UnitUtil.logSiPrefixes('J')),
      true,
      UnitUtil.coeff_n_n,
      'PrevodJednotek__Energie__N_NQ'
    );
  }
}
export class PrevodJednotek__Vykon__1 extends ConversionBaseAbc {
  constructor() {
    super(
      (r) => UnitUtil.getRandomOpts(r, UnitUtil.logSiPrefixes('W')),
      UnitUtil.coeff_1,
      'PrevodJednotek__Vykon__1'
    );
  }
}
export class PrevodJednotek__Vykon__N extends ConversionBaseAbc {
  constructor() {
    super(
      (r) => UnitUtil.getRandomOpts(r, UnitUtil.logSiPrefixes('W')),
      UnitUtil.coeff_n,
      'PrevodJednotek__Vykon__N'
    );
  }
}
export class PrevodJednotek__Vykon__N_N extends ConversionBaseAbc {
  constructor() {
    super(
      (r) => UnitUtil.getRandomOpts(r, UnitUtil.logSiPrefixes('W')),
      UnitUtil.coeff_n_n,
      'PrevodJednotek__Vykon__N_N'
    );
  }
}
export class PrevodJednotek__Vykon__1Q extends ConversionBaseSingle {
  constructor() {
    super(
      (r) => UnitUtil.getRandomConversion(r, UnitUtil.logSiPrefixes('W')),
      true,
      UnitUtil.coeff_1,
      'PrevodJednotek__Vykon__1Q'
    );
  }
}
export class PrevodJednotek__Vykon__NQ extends ConversionBaseSingle {
  constructor() {
    super(
      (r) => UnitUtil.getRandomConversion(r, UnitUtil.logSiPrefixes('W')),
      true,
      UnitUtil.coeff_n,
      'PrevodJednotek__Vykon__NQ'
    );
  }
}
export class PrevodJednotek__Vykon__N_NQ extends ConversionBaseSingle {
  constructor() {
    super(
      (r) => UnitUtil.getRandomConversion(r, UnitUtil.logSiPrefixes('W')),
      true,
      UnitUtil.coeff_n_n,
      'PrevodJednotek__Vykon__N_NQ'
    );
  }
}
export class PrevodJednotek__Tlak__1 extends ConversionBaseAbc {
  constructor() {
    super(
      (r) => UnitUtil.getRandomOpts(r, UnitUtil.logSiPrefixes('Pa')),
      UnitUtil.coeff_1,
      'PrevodJednotek__Tlak__1'
    );
  }
}
export class PrevodJednotek__Tlak__N extends ConversionBaseAbc {
  constructor() {
    super(
      (r) => UnitUtil.getRandomOpts(r, UnitUtil.logSiPrefixes('Pa')),
      UnitUtil.coeff_n,
      'PrevodJednotek__Tlak__N'
    );
  }
}
export class PrevodJednotek__Tlak__N_N extends ConversionBaseAbc {
  constructor() {
    super(
      (r) => UnitUtil.getRandomOpts(r, UnitUtil.logSiPrefixes('Pa')),
      UnitUtil.coeff_n_n,
      'PrevodJednotek__Tlak__N_N'
    );
  }
}
export class PrevodJednotek__Tlak__1Q extends ConversionBaseSingle {
  constructor() {
    super(
      (r) => UnitUtil.getRandomConversion(r, UnitUtil.logSiPrefixes('Pa')),
      true,
      UnitUtil.coeff_1,
      'PrevodJednotek__Tlak__1Q'
    );
  }
}
export class PrevodJednotek__Tlak__NQ extends ConversionBaseSingle {
  constructor() {
    super(
      (r) => UnitUtil.getRandomConversion(r, UnitUtil.logSiPrefixes('Pa')),
      true,
      UnitUtil.coeff_n,
      'PrevodJednotek__Tlak__NQ'
    );
  }
}
export class PrevodJednotek__Tlak__N_NQ extends ConversionBaseSingle {
  constructor() {
    super(
      (r) => UnitUtil.getRandomConversion(r, UnitUtil.logSiPrefixes('Pa')),
      true,
      UnitUtil.coeff_n_n,
      'PrevodJednotek__Tlak__N_NQ'
    );
  }
}
export class PrevodJednotek__Napeti__1 extends ConversionBaseAbc {
  constructor() {
    super(
      (r) => UnitUtil.getRandomOpts(r, UnitUtil.logSiPrefixes('V')),
      UnitUtil.coeff_1,
      'PrevodJednotek__Napeti__1'
    );
  }
}
export class PrevodJednotek__Napeti__N extends ConversionBaseAbc {
  constructor() {
    super(
      (r) => UnitUtil.getRandomOpts(r, UnitUtil.logSiPrefixes('V')),
      UnitUtil.coeff_n,
      'PrevodJednotek__Napeti__N'
    );
  }
}
export class PrevodJednotek__Napeti__N_N extends ConversionBaseAbc {
  constructor() {
    super(
      (r) => UnitUtil.getRandomOpts(r, UnitUtil.logSiPrefixes('V')),
      UnitUtil.coeff_n_n,
      'PrevodJednotek__Napeti__N_N'
    );
  }
}
export class PrevodJednotek__Napeti__1Q extends ConversionBaseSingle {
  constructor() {
    super(
      (r) => UnitUtil.getRandomConversion(r, UnitUtil.logSiPrefixes('V')),
      true,
      UnitUtil.coeff_1,
      'PrevodJednotek__Napeti__1Q'
    );
  }
}
export class PrevodJednotek__Napeti__NQ extends ConversionBaseSingle {
  constructor() {
    super(
      (r) => UnitUtil.getRandomConversion(r, UnitUtil.logSiPrefixes('V')),
      true,
      UnitUtil.coeff_n,
      'PrevodJednotek__Napeti__NQ'
    );
  }
}
export class PrevodJednotek__Napeti__N_NQ extends ConversionBaseSingle {
  constructor() {
    super(
      (r) => UnitUtil.getRandomConversion(r, UnitUtil.logSiPrefixes('V')),
      true,
      UnitUtil.coeff_n_n,
      'PrevodJednotek__Napeti__N_NQ'
    );
  }
}
export class PrevodJednotek__Proud__1 extends ConversionBaseAbc {
  constructor() {
    super(
      (r) => UnitUtil.getRandomOpts(r, UnitUtil.logSiPrefixes('A')),
      UnitUtil.coeff_1,
      'PrevodJednotek__Proud__1'
    );
  }
}
export class PrevodJednotek__Proud__N extends ConversionBaseAbc {
  constructor() {
    super(
      (r) => UnitUtil.getRandomOpts(r, UnitUtil.logSiPrefixes('A')),
      UnitUtil.coeff_n,
      'PrevodJednotek__Proud__N'
    );
  }
}
export class PrevodJednotek__Proud__N_N extends ConversionBaseAbc {
  constructor() {
    super(
      (r) => UnitUtil.getRandomOpts(r, UnitUtil.logSiPrefixes('A')),
      UnitUtil.coeff_n_n,
      'PrevodJednotek__Proud__N_N'
    );
  }
}
export class PrevodJednotek__Proud__1Q extends ConversionBaseSingle {
  constructor() {
    super(
      (r) => UnitUtil.getRandomConversion(r, UnitUtil.logSiPrefixes('A')),
      true,
      UnitUtil.coeff_1,
      'PrevodJednotek__Proud__1Q'
    );
  }
}
export class PrevodJednotek__Proud__NQ extends ConversionBaseSingle {
  constructor() {
    super(
      (r) => UnitUtil.getRandomConversion(r, UnitUtil.logSiPrefixes('A')),
      true,
      UnitUtil.coeff_n,
      'PrevodJednotek__Proud__NQ'
    );
  }
}
export class PrevodJednotek__Proud__N_NQ extends ConversionBaseSingle {
  constructor() {
    super(
      (r) => UnitUtil.getRandomConversion(r, UnitUtil.logSiPrefixes('A')),
      true,
      UnitUtil.coeff_n_n,
      'PrevodJednotek__Proud__N_NQ'
    );
  }
}
export class PrevodJednotek__Odpor__1 extends ConversionBaseAbc {
  constructor() {
    super(
      (r) => UnitUtil.getRandomOpts(r, UnitUtil.logSiPrefixes('Ω')),
      UnitUtil.coeff_1,
      'PrevodJednotek__Odpor__1'
    );
  }
}
export class PrevodJednotek__Odpor__N extends ConversionBaseAbc {
  constructor() {
    super(
      (r) => UnitUtil.getRandomOpts(r, UnitUtil.logSiPrefixes('Ω')),
      UnitUtil.coeff_n,
      'PrevodJednotek__Odpor__N'
    );
  }
}
export class PrevodJednotek__Odpor__N_N extends ConversionBaseAbc {
  constructor() {
    super(
      (r) => UnitUtil.getRandomOpts(r, UnitUtil.logSiPrefixes('Ω')),
      UnitUtil.coeff_n_n,
      'PrevodJednotek__Odpor__N_N'
    );
  }
}
export class PrevodJednotek__Odpor__1Q extends ConversionBaseSingle {
  constructor() {
    super(
      (r) => UnitUtil.getRandomConversion(r, UnitUtil.logSiPrefixes('Ω')),
      true,
      UnitUtil.coeff_1,
      'PrevodJednotek__Odpor__1Q'
    );
  }
}
export class PrevodJednotek__Odpor__NQ extends ConversionBaseSingle {
  constructor() {
    super(
      (r) => UnitUtil.getRandomConversion(r, UnitUtil.logSiPrefixes('Ω')),
      true,
      UnitUtil.coeff_n,
      'PrevodJednotek__Odpor__NQ'
    );
  }
}
export class PrevodJednotek__Odpor__N_NQ extends ConversionBaseSingle {
  constructor() {
    super(
      (r) => UnitUtil.getRandomConversion(r, UnitUtil.logSiPrefixes('Ω')),
      true,
      UnitUtil.coeff_n_n,
      'PrevodJednotek__Odpor__N_NQ'
    );
  }
}

export class PrevodJednotek__Stupne extends ConversionArrayAbc {
  constructor() {
    super(
      [0, 10, 15, 20, 30, 45, 60, 75, 90, 105, 120, 135, 150, 180, 225, 270, 315, 360],
      (i) => `${i}°`,
      (i) => `${new Fraction(Math.round(i / 15) * 15, 180).simplify().toNumber()  } π`,
      'PrevodJednotek__Stupne'
    );
  }
}

export class PrevodJednotek__Teplota_C_F extends ConversionArrayAbc {
  constructor() {
    super(
      [
        -50, -40, -30, -20, -10, 0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100, 200, 300, 400, 500,
        600, 700, 800, 900, 1000,
      ],
      (i) => `${i} °C`,
      (i) => `${((i * 9) / 5 + 32).toFixed(1)} °F`,
      'PrevodJednotek__Teplota_C_F'
    );
  }
}
